import { Grid } from "@mui/material";
import { useSuperAdminSublimacion } from "../../../context/SuperAdmin/SublimationContext";
import { CustomTab, CustomTabs } from "./CustomItems";
import { Spinner } from "../../Loading/Spinner";
import SublimSelectMenu from "./SublimSelectMenu";
import SublimacionTable from "./SublimacionTable";
import { useAuthContext } from "../../../hooks/Auth";

const SublimacionesSA = () => {
  const { tabValue, handleTabChange, isLoadingOpts } =
    useSuperAdminSublimacion();
  const { canAccess } = useAuthContext();
  const isSuperAdmin = canAccess("view:reports");
  return (
    <Grid
      container
      sx={{
        display: "flex",
        flexDirection: "column",
        width: 1,
        marginX: "auto",
        paddingX: 3,
        marginTop: 0,
        gap: 2,
      }}
    >
      {/* Tabs de tipo de sublimacion: usuarios, organizaciones o paises */}
      {isSuperAdmin && (
        <Grid item>
          <CustomTabs
            value={tabValue}
            onChange={(_, newValue: 0 | 1) => handleTabChange(newValue)}
            variant="fullWidth"
          >
            <CustomTab label="Organización" />
            <CustomTab label="País" />
          </CustomTabs>
        </Grid>
      )}

      {/* Si las opciones del select están cargando no se muestra nada */}
      {isLoadingOpts ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Selects más específico: usuarios, organizacines o paises */}
          {isSuperAdmin && (
            <Grid item>
              <SublimSelectMenu />
            </Grid>
          )}

          {/* Tabla de Eventos */}
          <Grid item>
            <SublimacionTable />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SublimacionesSA;
